<template>
  <main-content>
    <b-card>
      <ERegistrationHeaderFormInfo />
      <ERegistrationHelperUpgradeForm :invitation-key="invitationKey" />
    </b-card>
  </main-content>
</template>

<script>
import ERegistrationHelperUpgradeForm from "../components/e-registration-helper-upgrade/ERegistrationHelperUpgradeForm";
import ERegistrationHeaderFormInfo from "../components/e-registration-header-form/ERegistrationHeaderFormInfo"

export default {
  components: {
    ERegistrationHeaderFormInfo,
    ERegistrationHelperUpgradeForm
  },
  props: {
    invitationKey: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped></style>
